import { useState } from "react";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import WorkShiftService from "../../../../../services/WorkShiftService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const { canEdit, canDelete } = usePermissions();
	const workShiftService = new WorkShiftService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>{item?.time_from || "-"}</td>
			<td>{item?.time_to || "-"}</td>
			<td>{item?.allowance_time}</td>
			{/* <td>
				<Badge
					className="text-capitalize"
					variant={`${item.isActive ? "success" : "danger"} light`}>
					{item?.isActive ? Translate[lang].active : Translate[lang].deactive}
				</Badge>
			</td> */}
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{canEdit("work_shift") && (
						<img
							src={editIcon}
							className="cursor-pointer"
							onClick={() => {
								setAddModal(true);
								setItem(item);
							}}
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("work_shift") && (
						<img
							src={trashIcon}
							className="cursor-pointer"
							onClick={() => setDeleteModal(true)}
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={workShiftService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
